<div class="dialog-wrapper">
    <div class="icon">
        <img alt="Aviso" />
    </div>
    <p class="title">Você não possui permissão para executar essa ação.</p>
    <p class="subtitle">Entre em contato com o ponto focal da sua conta.</p>
    <a class="link-text" href="https://pessoas.unico.io"
        target="_blank" rel="noopener">Saiba mais sobre os perfis de acesso.</a>
    <div class="btn-wrapper">
        <button (click)="warningDialog.close(false)" class="btn-primary">OK</button>
    </div>
</div>
